module.exports = __webpack_public_path__ + "img/invitation_1.1b69b4d5.png";